import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import BaseWalkthrough from './walkthroughs/BaseWalkthrough';
import './PhoneWalkthrough.css';

interface PhoneWalkthroughProps {
  onClose: () => void;
}

const PhoneWalkthrough: React.FC<PhoneWalkthroughProps> = ({ onClose }) => {
  // Generate universal SMS QR code - works on all devices (iPhone, Android, etc.)
  const qrCodeUrl = 'sms:+16288679755?body=hi';

  return (
    <BaseWalkthrough
      title="Text Remi on your phone"
      subtitle="Choose one of the following options to get started:"
      onClose={onClose}
      className="phone-walkthrough"
    >
      <div className="phone-walkthrough-options">
        {/* Option 1: QR Code */}
        <div className="phone-option">
          <div className="option-label">Option 1</div>
          <h3 className="option-title">Scan QR Code</h3>
          <div className="phone-walkthrough-qr">
            <QRCodeSVG
              value={qrCodeUrl}
              size={200}
              level="H"
              includeMargin={true}
            />
          </div>
          <p className="option-description">Scan with your phone camera to start texting</p>
        </div>

        {/* Divider with OR */}
        <div className="options-divider">
          <div className="divider-line"></div>
          <div className="divider-text">OR</div>
          <div className="divider-line"></div>
        </div>

        {/* Option 2: Save Contact */}
        <div className="phone-option">
          <div className="option-label">Option 2</div>
          <h3 className="option-title">Save Remi's Contact</h3>
          <div className="phone-contact-info">
            <div className="contact-icon">📱</div>
            <div className="contact-number">+1 628-867-9755</div>
            <p className="contact-instruction">Save this number and text Remi directly</p>
          </div>
        </div>
      </div>

      <div className="phone-walkthrough-features">
        <p className="features-title">What you can do:</p>
        <div className="instruction-list">
          <div className="instruction-item">
            <span className="instruction-icon">📱</span>
            <span>Text with Remi to add people to CRM</span>
          </div>

          <div className="instruction-item">
            <span className="instruction-icon">✏️</span>
            <span>Update contacts and more</span>
          </div>

          <div className="instruction-item">
            <span className="instruction-icon">🎤</span>
            <span>Send voice notes - Remi will transcribe them</span>
          </div>

          <div className="instruction-item">
            <span className="instruction-icon">📊</span>
            <span>Remi will send daily updates about people in your network</span>
          </div>
        </div>
      </div>
    </BaseWalkthrough>
  );
};

export default PhoneWalkthrough;
